import { useLocale } from '@src/i18n/LocaleProvider'
import { cn } from '@src/utils/tailwind'

const isPriceZero = (price: string) => {
  // remove anything other than numbers and period
  return price.replace(/[^0-9.]/g, '') === '0.00'
}

export function LineItemPrice({
  basePrice,
  discountedPrice,
  stack,
  showFree,
}: {
  basePrice?: string
  discountedPrice?: string
  stack?: boolean
  showFree?: boolean
}) {
  const { t } = useLocale('common')
  if (!basePrice) return null

  if (!discountedPrice || discountedPrice === basePrice) {
    return <p className="ml-auto text-right text-body-md font-medium">{basePrice}</p>
  }

  const shouldShowFree = showFree && isPriceZero(discountedPrice)

  return (
    <div
      className={cn('flex items-end gap-2 text-body-md font-medium', {
        'flex-col gap-0': stack,
      })}
    >
      <span className="ml-auto text-bodi-gray-disabled line-through">{basePrice}</span>
      <span
        className={cn('text-bodi-black-text', {
          'text-bodi-green-deep-500 uppercase': shouldShowFree,
        })}
      >
        {shouldShowFree ? t('free') : discountedPrice}
      </span>
    </div>
  )
}
